import { sendBeacon } from "../fetch";
import { addMonitoringEventHandler } from "./bus";

addMonitoringEventHandler((event) => {
  if (event.type === "dataStreamEvent") {
    sendDataStreamEvent(event.eventName, event.properties);
  }
});

function sendDataStreamEvent(eventName: string, properties: JsonObject) {
  sendBeacon("/pixel/v1/i/dataStreamEventTracking/", {
    [eventName]: properties,
  });
}
